import React, { useEffect, useState, useRef } from "react";
import { Controller } from "react-hook-form";
import get from "lodash/get";
import { Text } from "src/components/ui/Text";
import clsx from "clsx";

const CheckBox = (props) => {
  const {
    name,
    control,
    groupOptions = {},
    required,
    label,
    subLabel,
    ...rest
  } = props;

  const [selectedOption, setSelectedOption] = useState([]);
  const valueRef = useRef();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, formState: { errors } }) => {
        const errorMsg = get(errors, `${name}.message`, undefined);
        const value = field.value;

        // Update selectedOption when value changes
        if (value !== valueRef.current) {
          valueRef.current = value;
          if (value) {
            setSelectedOption(value);
          } else {
            setSelectedOption([]);
          }
        }

        return (
          <div className="flex flex-col gap-3">
            <div className="flex items-end gap-2">
              <Text variant="bold-14">{label}</Text>
              <Text variant="normal-12">{`${subLabel} ${
                required ? "*" : ""
              }`}</Text>
              <Text
                variant="normal-12"
                className={`${errorMsg ? "text-vekin-message-error" : ""}`}
              >
                {errorMsg ? errorMsg : ""}
              </Text>
            </div>

            <div className="flex gap-3 h-7">
              {groupOptions?.length > 0 &&
                groupOptions.map((option) => {
                  const listName = option.name;
                  const id = option.id;
                  const checked =
                    selectedOption.some((item) => item.id === id) ||
                    value?.some((item) => item.id === id);
                  const isOpenTextForm = listName.includes("(โปรดระบุ)");

                  return (
                    <div key={option.id} className="flex gap-2 items-center">
                      <div
                        className={`flex items-center gap-1 ${
                          rest?.disabled ? "cursor-default" : "cursor-pointer"
                        }`}
                        onClick={() => {
                          if (rest?.disabled) return;

                          if (checked) {
                            const selected = selectedOption.filter(
                              (item) => item.id !== id
                            );
                            if (selected.length === 0) {
                              setSelectedOption([]);
                              field.onChange(undefined);
                            } else {
                              setSelectedOption(selected);
                              field.onChange(selected);
                            }

                            return;
                          } else {
                            const selected = [
                              ...selectedOption,
                              { name: listName, id: id },
                            ];
                            setSelectedOption(selected);
                            field.onChange(selected);
                            return;
                          }
                        }}
                      >
                        <input
                          name={name}
                          type="checkbox"
                          checked={checked}
                          className={`w-4 h-4 accent-vekin !rounded-full ${
                            rest?.disabled ? "cursor-default" : "cursor-pointer"
                          }`}
                          readOnly
                          {...rest}
                        />
                        <Text
                          variant={"normal-12"}
                          className={`${clsx(
                            checked && "text-vekin-green100"
                          )}`}
                        >
                          {listName}
                        </Text>
                      </div>
                      <div>
                        {checked && isOpenTextForm ? (
                          <div className="pl-2">
                            <input
                              disabled={rest?.disabled}
                              type="text"
                              value={
                                value?.find((item) => item.id === id)?.words
                              }
                              className={`border-b-[1px] border-vekin-green100 rounded-b-md text-sm text-vekin px-2 ${
                                rest?.disabled
                                  ? "bg-transparent !text-quartenary !border-quartenary"
                                  : ""
                              }`}
                              onChange={(e) => {
                                if (rest?.disabled) return;

                                const setValue = selectedOption.map((item) => {
                                  if (item.id === id) {
                                    return { ...item, words: e.target.value };
                                  }
                                  return item;
                                });

                                field.onChange(setValue);
                              }}
                            />
                          </div>
                        ) : null}
                      </div>
                    </div>
                  );
                })}
            </div>
          </div>
        );
      }}
    />
  );
};

export default CheckBox;
